<template>
  <div>
    <div class="flex">
      <div class="ml-a">
        <a class="btn-primary" href="/faqs/manage-categories">
          Manage Categories
        </a>
      </div>
      <div>
        <a class="btn-primary" href="/faqs/create">
          Create FAQ
        </a>
      </div>
    </div>
    <div class="faq-types">
      <div v-for="faq_type in faq_types" class="faq-type">
        <div class="faq-type-header" @click="toggleOpenFaqType(faq_type.id)">
          <h1 class="faq-type-label">{{ faq_type.label }}</h1>
          <div class="faq-type-toggle">
            <i class="fal fa-chevron-up" v-if="open_faq_types.includes(faq_type.id)"></i>
            <i class="fal fa-chevron-down" v-if="!open_faq_types.includes(faq_type.id)"></i>
          </div>
        </div>
        <div class="faq-categories" v-show="open_faq_types.includes(faq_type.id)">
          <div v-for="faq_category in faq_type.faq_categories" class="faq-category">
            <div class="faq-category-header" @click="toggleOpenFaqCategory(faq_category.id)">
              <h2 class="faq-category-label">{{ faq_category.label }}</h2>
              <div class="faq-category-toggle">
                <i class="fal fa-chevron-up" v-if="open_faq_categories.includes(faq_category.id)"></i>
                <i class="fal fa-chevron-down" v-if="!open_faq_categories.includes(faq_category.id)"></i>
              </div>
            </div>
            <div class="faqs" v-show="open_faq_categories.includes(faq_category.id)">
              <div v-for="faq in faq_category.faqs" :class="{ '_unpublished' : !faq.published }" class="faq">
                <div class="faq-header">
                  <h3 class="faq-question">{{ faq.question }}</h3>
                  <div>
                    <a :href="`/faqs/edit/${faq.id}`">
                      <span v-if="!faq.published" class="txt-danger pr-3">
                        Unpublished
                      </span>
                      <i class="fal fa-pencil"></i>
                    </a>
                  </div>
                </div>
                <div class="faq-answer" v-html="faq.answer"></div>
              </div>
              <div v-if="faq_category.faqs.length === 0" class="faq">
                No FAQs found
              </div>
            </div>
          </div>
          <div v-if="faq_type.faq_categories.length === 0" class="faq-category p-6">
            No Categories Found
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
  ],
  data() {
    return {
      faq_types: [],
      loading: true,
      open_faq_types: [],
      open_faq_categories: [],
    };
  },
  computed: {
  },
  mounted() {
    this.loadFaqs();
  },
  methods: {
    loadFaqs: _.debounce(function () {
      axios.post('/faqs/loadFaqsForAdmin', {
      }).then((response) => {
        this.faq_types = response.data;

        this.faq_types.forEach((type) => {
          this.open_faq_types.push(type.id);
          // type.faq_categories.forEach((category) => {
          //   this.open_faq_categories.push(category.id);
          // });
        });

        this.loading = false;

      });
    }, 250),
    toggleOpenFaqType(faq_type_id) {
      if(this.open_faq_types.includes(faq_type_id)) {
        let index = this.open_faq_types.indexOf(faq_type_id);
        if (index > -1) {
          this.open_faq_types.splice(index, 1);
        }
      } else {
        this.open_faq_types.push(faq_type_id);
      }
    },
    toggleOpenFaqCategory(faq_category_id) {
      if(this.open_faq_categories.includes(faq_category_id)) {
        let index = this.open_faq_categories.indexOf(faq_category_id);
        if (index > -1) {
          this.open_faq_categories.splice(index, 1);
        }
      } else {
        this.open_faq_categories.push(faq_category_id);
      }
    },
  },
  watch: {
  },
};
</script>
